import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import imageStream from '@/components/layout/imageStream/ImageStream.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import util from '@/util'
import cnpj from '@/util/cnpj'
import mensagens from '@/util/mensagens'
import { BSpinner } from 'bootstrap-vue'
import { mapState } from 'vuex'
import mascaras from '@/util/mascaras'
import { filtrosMixin } from '@/modules/filtros/mixins'

export default {
  name: 'escritorios',
  components: {
    cabecalho,
    menuLateral,
    pagination,
    imageStream,
    'default-table': defaultTable,
    'b-spinner': BSpinner
  },

  mixins: [ filtrosMixin ],
  data: () => {
    return {
      listaEscritorios: [],
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      },
      camposFiltroPesquisa: {
        nome: null,
        nomeFantasia: null,
        email: null,
        cpf_cnpj: null,
        status: 1,
        id_contexto: null,
        codigo_empresa: null
      },
      filtrosPesquisa: [],
      componenteOrdenacao: {
        campo: 'nome',
        sentido: 'asc'
      },
      statusFiltroOptions: [
        { text: '', value: null },
        { text: 'Ativo', value: 1 },
        { text: 'Inativo', value: 0 },
        { text: 'Inadimplente', value: 2 },
        { text: 'Suspenso', value: 3 }
      ],
      items: [],
      fields: [
        { key: 'nome', sortable: true, label: 'Nome ou Razão Social' },
        {
          key: 'nome_fantasia',
          sortable: true,
          label: 'Nome Fantasia',
          formatter: (value) => value || '-----'
        },
        { key: 'email', sortable: true, label: 'E-mail' },
        {
          key: 'cpf_cnpj',
          sortable: true,
          label: 'CPF/CNPJ'
        },
        {
          key: 'codigo_empresa',
          sortable: true,
          label: 'Código Empresa'
        },
        {
          key: 'status',
          sortable: false,
          label: 'Status',
          formatter: (value) => {
            switch (value) {
              case 1: return 'Ativo'
              case 0: return 'Inativo'
              case 2: return 'Inadimplente'
              case 3: return 'Suspenso'
              default: return '-----'
            }
          }
        }
      ],
      comboContextoProduto: []
    }
  },

  computed: {
    ...mapState('pagination', ['registrosPorPagina'])
  },

  mounted () {
    this.definirContexto('escritorio')
    this.obterContextosProduto()
    this.camposFiltroPesquisa = this.inicializarFiltrosPesquisa(this.camposFiltroPesquisa)
    this.componenteOrdenacao = this.inicializarComponenteOrdenacao(this.componenteOrdenacao)
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    this.buscarRegistros()
  },

  methods: {
    limparFiltros () {
      this.limparFiltrosPesquisa()
      this.camposFiltroPesquisa = {
        nome: null,
        nomeFantasia: null,
        email: null,
        cpf_cnpj: null,
        status: 1,
        id_contexto: null,
        codigo_empresa: null
      }
      this.limparComponenteOrdenacao()
      this.componenteOrdenacao = {
        campo: 'nome',
        sentido: 'asc'
      }
    },
    escritorioTemLogo (logotipo) {
      if (util.valorVazio(logotipo)) {
        return false
      }

      return true
    },
    async obterListaEscritorios () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
        const parametrosRequisicao = {
          'page': this.componentePaginacao.pagina,
          'registrosPorPagina': this.componentePaginacao.registrosPorPagina,
          'filtros': this.filtrosPesquisa,
          'ordenacao': this.componenteOrdenacao
        }
        const resposta = await this.axios.post('/escritorios', parametrosRequisicao)
        this.listaEscritorios = resposta.data.retorno.dados
        this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
        this.componentePaginacao.ultimaPagina = resposta.data.retorno.paginacao.ultimaPagina
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },
    tabelaSemRegistros (item, type) {
      if (util.valorVazio(item) && type === 'row-empty') {
        return 'text-center'
      }
    },
    ordenarLista (context) {
      if (!util.valorVazio(context.sortBy)) {
        this.componenteOrdenacao.campo = context.sortBy
        this.componenteOrdenacao.sentido = context.sortDesc === true ? 'desc' : 'asc'
        this.salvarComponenteOrdenacao(this.componenteOrdenacao)
        this.obterListaEscritorios()
      }
    },
    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaEscritorios()
    },

    buscarRegistros () {
      this.filtrosPesquisa = util.mapearObjetos(this.camposFiltroPesquisa, {})
      this.filtrosPesquisa.cpf_cnpj = cnpj.normalizarCnpj(this.filtrosPesquisa.cpf_cnpj)
      this.salvarFiltrosPesquisa(this.filtrosPesquisa)
      this.salvarComponenteOrdenacao(this.componenteOrdenacao)
      this.componentePaginacao.pagina = 1
      this.obterListaEscritorios()
    },
    editarEscritorio (id) {
      this.$router.push({ name: 'edicao-escritorio', params: { id: id } })
    },
    mascaraDocumentoIdentificacao (valor) {
      return mascaras.mascaraCpfCnpj(valor)
    },
    destacarEscritorioInativo (ativo) {
      if (ativo === false) {
        return 'text-secondary'
      } else {
        return 'textos'
      }
    },
    async obterContextosProduto () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
        const resposta = await this.axios.get('/escritorios/contextos-produto')
        const dadosResposta = resposta.data.retorno.dados
        const comboMapeado = dadosResposta.map(produto => ({
          value: produto.id,
          text: produto.nome
        }))
        this.comboContextoProduto = [{ value: null, text: '' }].concat(comboMapeado)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      } finally {
        this.definirFlagCarregandoDados(false, '')
      }
    },

    incluirEscritorio () {
      this.$router.push({ name: 'cadastro-escritorio' })
    }
  }
}
